import IBroker from "@/module/main/model/applicationForm/IBroker";

export default class Broker implements IBroker
{
    constructor(public merchantName: string = "")
    {
    }
}
